/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { AppUserActions, NAMESPACE } from '../app-user.reducer';
import { switchMap, catchError, tap } from 'rxjs/operators';

import { AppSessionUser } from '../../domain/app-session-user.entity';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { of, from } from 'rxjs';
import CognitoService from '../../services/cognito';

@Injectable()
export class AppUserEffects {

  constructor(
    private action$: Actions,
    private localStorage: LocalStorageService,
    private cognitoService: CognitoService
  ) {}

  init$ = createEffect(() =>
      this.action$.pipe(
        ofType(AppUserActions.INIT),
        switchMap(() => {
          try {
            const local = this.localStorage?.get(NAMESPACE) as AppSessionUser;

            if (local && typeof local === 'object') {
              const cognitoUser = this.cognitoService.getCurrentUser();

              if (cognitoUser) {
                return from(new Promise<any>((resolve) => {
                  cognitoUser.getSession((err, session) => {
                    if (err || !session || !session.isValid()) {
                      this.localStorage.remove(NAMESPACE);
                      resolve({ type: AppUserActions.KEEP_CURRENT_STATE });
                    } else {
                      resolve({ type: AppUserActions.SET_SESSION_USER, payload: local });
                    }
                  });
                }));
              } else {
                this.localStorage.remove(NAMESPACE);
                return of({ type: AppUserActions.KEEP_CURRENT_STATE });
              }
            } else {
              return of({ type: AppUserActions.KEEP_CURRENT_STATE });
            }
          } catch (error) {
            console.error('Error in AppUser init$ effect:', error);
            return of({ type: AppUserActions.KEEP_CURRENT_STATE });
          }
        }),
        catchError((error) => {
          console.error('Fatal error in AppUser init$ effect:', error);
          return of({ type: AppUserActions.KEEP_CURRENT_STATE });
        })
      )
    );

  saveOnLs$ = createEffect(() =>
    this.action$.pipe(
      ofType(AppUserActions.SET_SESSION_USER),
      tap((action: any) => {
        try {
          if (action?.payload && this.localStorage) {
            this.localStorage.set(NAMESPACE, action.payload);
          }
        } catch (error) {
          console.error('Error saving AppUser to localStorage:', error);
        }
      })
    ), { dispatch: false });
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
